


export const FeaturedImageSection = () => (
  <div className="space-y-3">
    <h3 className="text-xs font-semibold uppercase text-muted-foreground">Featured Image</h3>
    <div className="border-2 border-dashed rounded-md p-6 flex flex-col items-center justify-center text-center cursor-pointer hover:bg-muted/50 transition-colors">
      <span className="text-sm text-muted-foreground">Click to upload</span>
    </div>
  </div>
);
